import axios from "axios";
import Auth from "../service/AuthService";
import AuthService from "../service/AuthService";
import qs from "qs";

const Component = {
  /**
   * Transactions API
   */

  getTransactions: async function ({
    trnDateMin,
    trnDateMax,
    totalRiskMin,
    totalRiskMax,
    transactionTypes,
    pans,
    merchantCodes,
    statuses,
    detailStatuses,
    riskEvaluationStatuses,
    rejectReasonCodes,
    transactionIds,
    isEstimatedFraud,
    isFraud,
    isHotspot,
    ewPayOnly,
    directPurchaseOnly,
    offset,
    pageSize,
    displayCount,
  }) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/transactions",
      params: {
        trnDateMin,
        trnDateMax,
        totalRiskMin,
        totalRiskMax,
        transactionTypes,
        pans,
        merchantCodes,
        statuses,
        detailStatuses,
        riskEvaluationStatuses,
        rejectReasonCodes,
        transactionIds,
        isEstimatedFraud,
        isFraud,
        isHotspot,
        ewPayOnly,
        directPurchaseOnly,
        offset,
        pageSize,
        displayCount,
      },
    });
    return await response.data;
  },

  /**
   * Customer History Patterns API
   */
  getCustomerHistoryPatterns: async function ({
    companyId,
    merchantCode,
    tier,
    dominantHour,
    slotsValidMin,
    slotsValidMax,
    pageSize,
    offset,
    displayCount,
  }) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/customer-history-patterns",
      params: {
        companyId,
        merchantCode,
        tier,
        dominantHour,
        slotsValidMin,
        slotsValidMax,
        pageSize,
        offset,
        displayCount,
      },
    });

    return response.data;
  },

  /**
   * Cache API
   */

  getLatestCache: async function (cacheType) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/caches/latest",
      params: { cacheType: cacheType },
    });
    return await response.data;
  },

  /**
   * Config API
   */

  getLatestConfig: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/configs/latest",
    });
    return await response.data;
  },
  getConfig: async function (id) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/configs/" + id,
    });
    return await response.data;
  },
  createConfig: async function (config) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/configs",
      data: config,
    });
    return response.data;
  },
  getConfigHeaders: async function (idMin, idMax, limit) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/configs/headers",
      params: {
        idMin: idMin,
        idMax: idMax,
        limit: limit,
      },
    });
    return await response.data;
  },
  getConfigEfficiency: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/statistics/config-efficiency",
    });
    return response.data;
  },
  revertToBenchmarkConfig: async function (configId) {
    const config = await this.getConfig(configId);
    return this.createConfig(config);
  },

  /**
   * General config API
   */

  getLatestGeneralConfig: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/general-configs/latest",
    });
    return await response.data;
  },
  createGeneralConfig: async function (config) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/general-configs",
      data: config,
    });
    return response.data;
  },

  /**
   * Job API
   */

  getJobs: async function (ids, jobTypes) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/jobs",
      params: {
        ids,
        jobTypes,
      },
    });
    return await response.data;
  },
  postJob: async function (job) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/jobs",
      data: job,
    });
    return await response.data;
  },

  getJobHeaders: async function (jobTypes) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/jobs/headers",
      params: {
        jobTypes,
      },
    });
    return await response.data;
  },

  /**
   * Odometers API
   */

  getOdometers: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/odometers",
    });
    return await response.data;
  },
  replaceOdometers: async function (odometers) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/odometers/replace",
      data: odometers,
    });
    return await response.data;
  },

  /**
   * Merchant Hotspot API
   */

  getMerchantHotspots: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/merchant-hotspots",
    });
    return await response.data;
  },
  replaceMerchantHotspots: async function (hotspots) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/merchant-hotspots/replace",
      data: hotspots,
    });
    return await response.data;
  },

  /**
   * Merchant Info API
   */

  getMerchantInfos: async function (merchantCodes) {
    // FIXME: hotfix for API gateway
    merchantCodes = merchantCodes.slice(0, 200);

    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/merchant-infos",
      params: {
        merchantCodes,
      },
    });
    return await response.data;
  },

  /**
   * Import API
   */

  storeTransactionsFromXlsx: async function (s3FileName) {
    const response = await this.callRaw({
      method: "POST",
      url:
        process.env.REACT_APP_PABLO_API +
        "/imports/store-transactions-from-xlsx",
      params: {
        s3FileName: s3FileName,
      },
    });
    return response?.data;
  },
  storeProductsFromXlsx: async function (s3FileName) {
    const response = await this.callRaw({
      method: "POST",
      url:
        process.env.REACT_APP_PABLO_API + "/imports/store-products-from-xlsx",
      params: {
        s3FileName: s3FileName,
      },
    });
    return response?.data;
  },
  storeFraudsFromXlsx: async function (s3FileName) {
    const response = await this.callRaw({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/imports/store-frauds-from-xlsx",
      params: {
        s3FileName: s3FileName,
      },
    });
    return response?.data;
  },

  /**
   * Export API
   */

  /**
   * Returns { httpStatus, jobId?, fileName? }
   * httpStatus 202 → new job started, jobId is set
   * httpStatus 409 → file already exists in S3, fileName is set
   */
  generateRiskEvaluationExcelToS3: async function ({
    trnDateMin,
    trnDateMax,
    totalRiskMin,
    totalRiskMax,
    transactionTypes,
    pans,
    merchantCodes,
    statuses,
    detailStatuses,
    riskEvaluationStatuses,
    rejectReasonCodes,
    transactionIds,
    isEstimatedFraud,
    isFraud,
    isHotspot,
    dateTimeFormat,
    forceRegenerate,
  }) {
    const response = await this.callRaw({
      method: "POST",
      url:
        process.env.REACT_APP_PABLO_API +
        "/exports/generate-risk-evaluation-excel-to-s3",
      params: {
        trnDateMin,
        trnDateMax,
        totalRiskMin,
        totalRiskMax,
        transactionTypes,
        pans,
        merchantCodes,
        statuses,
        detailStatuses,
        riskEvaluationStatuses,
        rejectReasonCodes,
        transactionIds,
        isEstimatedFraud,
        isFraud,
        isHotspot,
        dateTimeFormat: dateTimeFormat || undefined,
        forceRegenerate: forceRegenerate === true ? true : undefined,
      },
    });
    if (response.status === 409) {
      return { httpStatus: 409, fileName: response.data };
    }
    return { httpStatus: 202, jobId: response.data };
  },
  /**
   * Returns { httpStatus, jobId?, fileName? }
   * httpStatus 202 → new job started, jobId is set
   * httpStatus 409 → file already exists in S3, fileName is set
   */
  generateMerchantInfoExcelToS3: async function ({ forceRegenerate } = {}) {
    const response = await this.callRaw({
      method: "POST",
      url:
        process.env.REACT_APP_PABLO_API +
        "/exports/generate-merchant-info-excel-to-s3",
      params: {
        forceRegenerate: forceRegenerate === true ? true : undefined,
      },
    });
    if (response.status === 409) {
      return { httpStatus: 409, fileName: response.data };
    }
    return { httpStatus: 202, jobId: response.data };
  },
  getExportStatus: async function (jobId) {
    const response = await this.callRaw({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/exports/status/" + jobId,
    });
    if (!response || response.status >= 500) {
      throw new Error(
        response ? "Server error " + response.status : "Network error",
      );
    }
    return response.data;
  },
  listExportFiles: async function (prefix) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/exports/list",
      params: prefix ? { prefix } : {},
    });
    return response.data;
  },
  /**
   * Returns { httpStatus, jobId?, fileName? }
   * httpStatus 202 → new job started, jobId is set
   * httpStatus 409 → file already exists in S3, fileName is set
   */
  generateAuditLogExcelToS3: async function ({
    createdMin,
    createdMax,
    userId,
    excludeUserIds,
    eventTypes,
    forceRegenerate,
  } = {}) {
    const response = await this.callRaw({
      method: "POST",
      url:
        process.env.REACT_APP_PABLO_API +
        "/exports/generate-audit-log-excel-to-s3",
      params: {
        createdMin,
        createdMax,
        userId: userId || undefined,
        excludeUserIds:
          excludeUserIds && excludeUserIds.length > 0
            ? excludeUserIds
            : undefined,
        eventTypes:
          eventTypes && eventTypes.length > 0 ? eventTypes : undefined,
        forceRegenerate: forceRegenerate === true ? true : undefined,
      },
    });
    if (response.status === 409) {
      return { httpStatus: 409, fileName: response.data };
    }
    return { httpStatus: 202, jobId: response.data };
  },
  cancelExport: async function (jobId) {
    await this.callRaw({
      method: "DELETE",
      url: process.env.REACT_APP_PABLO_API + "/exports/cancel/" + jobId,
    });
  },

  /**
   * Statistics API
   */

  getRefuelingVolumeByPercentile: async function () {
    const response = await this.call({
      method: "GET",
      url:
        process.env.REACT_APP_PABLO_API +
        "/statistics/refueling-volume-by-percentile",
      params: {},
    });
    return await response.data;
  },
  getPanVolumesWithFrauds: async function () {
    const response = await this.call({
      method: "GET",
      url:
        process.env.REACT_APP_PABLO_API + "/statistics/pan-volumes-with-frauds",
      params: {},
    });
    return await response.data;
  },
  getFalsePositiveTotalRisks: async function (trnDateMin, trnDateMax) {
    const response = await this.call({
      method: "GET",
      url:
        process.env.REACT_APP_PABLO_API +
        "/statistics/false-positives-total-risks",
      params: { trnDateMin, trnDateMax },
    });
    return await response.data;
  },

  /**
   * Rule Analysis API
   */

  getRuleImpact: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/rule-analysis/impact",
    });
    return response.data;
  },
  getBestConfigWeights: async function () {
    const response = await this.call({
      method: "GET",
      url:
        process.env.REACT_APP_PABLO_API + "/rule-analysis/best-config-weights",
    });
    return response.data;
  },
  triggerRuleImpactUpdate: async function () {
    await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/rule-analysis/impact/trigger",
    });
  },

  /**
   * Simulation API
   */

  getRuleInfo: async function (trnDateMin, trnDateMax) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/simulations/rule-info",
      params: { trnDateMin, trnDateMax },
    });
    return await response.data;
  },
  getCalculateWeightsJobResultDetails: async function (jobIds) {
    // POST (not GET) for this read: jobIds go in the body to avoid a long URL that (with the JWT header) would exceed the server header size limit -> 400.
    const response = await this.call({
      method: "POST",
      url:
        process.env.REACT_APP_PABLO_API +
        "/simulations/calculate-weights-job-result-detail",
      data: jobIds,
    });
    return await response.data;
  },
  getCalculateWeightsJobResultRowDetail: async function (jobId, resultId) {
    const response = await this.call({
      method: "GET",
      url:
        process.env.REACT_APP_PABLO_API +
        "/simulations/calculate-weights-job-result-row-detail",
      params: { jobId, resultId },
    });
    return await response.data;
  },
  setConfigWeights: async function (jobId, resultId) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/simulations/set-config-weights",
      params: { jobId, resultId },
    });
    return await response.data;
  },

  /**
   * Backtester API
   */

  evaluateBacktester: async function (weightOverrides) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/backtester/evaluate",
      data: { weightOverrides },
    });
    return await response.data;
  },
  getBacktesterDatasetInfo: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/backtester/dataset-info",
    });
    return await response.data;
  },
  rebuildBacktester: async function () {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/backtester/rebuild",
    });
    return await response.data;
  },
  getBacktesterTransactionDetails: async function (weightOverrides, filters, paging) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/backtester/transaction-details",
      data: {
        weightOverrides,
        pan: (filters && filters.pan) || null,
        transactionUid: (filters && filters.transactionUid) || null,
        merchantCode: (filters && filters.merchantCode) || null,
        countryCode: (filters && filters.countryCode) || null,
        classifications: (filters && filters.classifications) || null,
        page: (paging && paging.page) || 0,
        pageSize: (paging && paging.pageSize) || 50,
      },
    });
    return await response.data;
  },

  /**
   * Notes API
   */

  getNotes: async function (
    targetPathStartsWith,
    targetIdMax,
    excludeAuthors,
    pageSize,
  ) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/notes",
      params: {
        targetPathStartsWith,
        targetIdMax,
        excludeAuthors,
        pageSize,
      },
    });
    return await response.data;
  },
  createNote: async function (note) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/notes",
      data: note,
    });
    return await response.data;
  },
  updateNote: async function (note) {
    const response = await this.call({
      method: "PUT",
      url: process.env.REACT_APP_PABLO_API + "/notes",
      data: note,
    });
    return await response.data;
  },
  deleteNote: async function (note) {
    const response = await this.call({
      method: "DELETE",
      url: process.env.REACT_APP_PABLO_API + "/notes/" + note.id,
      data: note,
    });
    return await response.data;
  },

  /**
   * Management API
   * Spring Boot management endpoints exposed on port 9090 (metrics, info, health)
   */

  getVersion: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/actuator/info",
    });

    // Handle null response (network/CORS error)
    if (!response || !response.data) {
      return "Unknown";
    }

    return response.data.build.version ?? "Unknown";
  },

  /**
   * Limits API
   */

  getCustomerEwPayLimit: async function (companyId, pan) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/limits/customer-ew-pay",
      params: {
        companyId,
        pan: pan || undefined,
      },
    });
    return response?.data;
  },

  /**
   * Vulnerable PAN API
   */

  getVulnerablePans: async function () {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/vulnerable-pans",
    });
    return await response.data;
  },
  createVulnerablePan: async function (pan, merchantId, expirationMinutes) {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/vulnerable-pans",
      data: {
        pan,
        merchantId: merchantId || null,
        expirationMinutes,
      },
    });
    return response.data;
  },
  deleteVulnerablePan: async function (id) {
    const response = await this.call({
      method: "DELETE",
      url: process.env.REACT_APP_PABLO_API + "/vulnerable-pans/" + id,
    });
    return response.data;
  },

  /**
   * Auditlog API
   */

  getAuditlogs: async function (params) {
    const response = await this.call({
      method: "GET",
      url: process.env.REACT_APP_PABLO_API + "/auditlogs",
      params: {
        createdMin: params.createdMin,
        createdMax: params.createdMax,
        userId: params.userId || null,
        excludeUserIds: params.excludeUserIds || null,
        eventTypes: params.eventTypes || null,
        pageSize: params.pageSize || 30,
        offset: params.offset || 0,
        displayCount: params.displayCount !== false, // default true
      },
    });

    return response.data;
  },

  logUserLoginAuditlog: async function () {
    const response = await this.call({
      method: "POST",
      url: process.env.REACT_APP_PABLO_API + "/auditlogs/log-user-login",
    });

    return response.data;
  },

  /**
   * Util methods
   */

  async call(params) {
    // Create header

    // Get access token for API calls (backend expects access token with proper audience)
    let accessToken = null;
    try {
      accessToken = await Auth.getAccessToken();
    } catch (error) {
      console.error("Failed to acquire access token:", error);
    }

    // Fallback to ID token if access token is not available
    const idToken = Auth.getIdToken();

    // Use access token (backend is OAuth2 resource server expecting access tokens)
    const token = accessToken || idToken;
    const authHeader = token ? "Bearer " + token : null;

    // Create axios object

    const p = {
      ...params,
      headers: {
        Authorization: authHeader,
        ...params.headers,
      },
    };

    // Create custom Axios instance

    const axiosInstance = axios.create({
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "comma", skipNulls: true }); // Must be: "url?myArray[]=1,2,3,4,5" to avoid issue in API Gateway has problem
      },
    });

    // Call

    try {
      return await axiosInstance(p);
    } catch (e) {
      this.handleError(e);
      // Return null to prevent calling code from crashing when accessing response.data
      return null;
    }
  },

  /**
   * Like call(), but does NOT throw on 4xx/5xx — returns the full response.
   * Use this when you need to inspect the status code (e.g. 409 Conflict).
   */
  async callRaw(params) {
    const accessToken = await Auth.getAccessToken();
    const token = accessToken || Auth.getIdToken();
    const authHeader = token ? "Bearer " + token : null;
    const p = {
      ...params,
      validateStatus: () => true, // never throw on any HTTP status
      headers: {
        Authorization: authHeader,
        ...params.headers,
      },
    };
    const axiosInstance = axios.create({
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "comma", skipNulls: true });
      },
    });
    return await axiosInstance(p);
  },
  handleError(e) {
    if (e.message.includes("Network Error") || !e.response) {
      console.error("Network/CORS error:", e.message);
      return;
    }

    let msg = "";
    if (e.message.includes("403")) {
      msg =
        "User " +
        AuthService.getUserName() +
        " has no rights to perform this action.";
    } else if (e.message.includes("401")) {
      msg = "User is unauthorized. Please try re-login.";
    } else if (e.message.includes("400")) {
      msg = "Invalid format.";
    } else {
      msg =
        "An error happened when calling the server.\n\nError details: " +
        "\n" +
        e.message;

      // Add server error message if available
      if (e.response && e.response.data && e.response.data.errorMsg) {
        msg += "\n" + e.response.data.errorMsg;
      }
    }
    if (msg != null) {
      window.alert(msg);
    }
  },
};

export default Component;
